import type { ThemeOptions } from '@mui/material';

import GTAmericaMonoMedium from '~/styles/fonts/GT-America/GT-America-Mono-Medium.woff2';
import GTAmericaMonoRegular from '~/styles/fonts/GT-America/GT-America-Mono-Regular.woff2';
import GTAmericaStandardLight from '~/styles/fonts/GT-America/GT-America-Standard-Light.woff2';
import GTAmericaStandardMedium from '~/styles/fonts/GT-America/GT-America-Standard-Medium.woff2';
import GTAmericaStandardRegular from '~/styles/fonts/GT-America/GT-America-Standard-Regular.woff2';

const CSSBaseline: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: ` @font-face {
      font-family: 'GT America';
      font-style: normal;
      font-weight: 300;
      src: url(${GTAmericaStandardLight}) format("woff2");
    }
    @font-face {
      font-family: 'GT America';
      font-style: normal;
      font-weight: 400;
      src: url(${GTAmericaStandardRegular}) format("woff2");
    }
    @font-face {
      font-family: 'GT America';
      font-style: normal;
      font-weight: 500;
      src: url(${GTAmericaStandardMedium}) format("woff2");
    }
    @font-face {
      font-family: 'GT America Mono';
      font-style: normal;
      font-weight: 400;
      src: url(${GTAmericaMonoRegular}) format("woff2");
    }
    @font-face {
      font-family: 'GT America Mono';
      font-style: normal;
      font-weight: 500;
      src: url(${GTAmericaMonoMedium}) format("woff2");
    }`,
  },
};

export default CSSBaseline;
